<e-dialog [open]="target() !== null" (openChange)="onOpenChange($event)" [title]="text().title">
  <ng-template>
    <div class="rename-form">
      <input
        class="rename-input"
        type="text"
        [placeholder]="text().placeholder"
        [ngModel]="name()"
        (ngModelChange)="name.set($event)"
        (keydown.enter)="submit()"
      />
      <button eBtn color="primary-75" icon="check" [disabled]="!canSave" (click)="submit()">
        {{ text().save }}
      </button>
    </div>
  </ng-template>
</e-dialog>
